import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import useSearchQueryFilter from 'dpl/breeder_search_results/hooks/useSearchQueryFilter';
import Checkbox from 'dpl/common/design_system/Checkbox';
import { FILTER_PARAMS } from 'dpl/puppy_search_results/utils/constants';
import TooltipWrapper from 'dpl/common/tooltip/components/TooltipWrapper';
import Icon from 'dpl/common/components/Icon';
import { TOOLTIP_VARIANTS } from 'dpl/common/utils/constants';

export default function MultiSelectChecklistFilter({
  filterTitle,
  filterParam,
  filterOptions,
  filterTooltipText
}) {
  const { searchQueryFilterValues, toggleFilter } =
    useSearchQueryFilter(filterParam);

  return (
    <>
      {Boolean(filterTitle) && (
        <div className="mb4 font-16 fw-medium md:font-18 md:font-serif flex items-center">
          {filterTitle}
          {filterTooltipText && (
            <TooltipWrapper
              data-test-id="filter-tooltip"
              title={filterTooltipText}
              minWidth="250px"
              className="z-max"
              variant={TOOLTIP_VARIANTS.MIDNIGHT}
              tooltipTextClassName="pt15"
              disablePositionReset
            >
              <Icon
                name="fetch-question"
                width="20"
                height="20"
                className="ml2 secondary"
              />
            </TooltipWrapper>
          )}
        </div>
      )}
      {filterOptions.map(({ title, value }) => (
        <div
          key={value}
          className={classnames(
            'mb4',
            `SearchResultFilters${filterTitle}Filter`
          )}
        >
          <Checkbox
            key={value}
            id={`${filterParam}_${value}`}
            name={title}
            value={value}
            label={title}
            checked={searchQueryFilterValues.includes(Number(value))}
            onChange={e => toggleFilter(Number(e.target.value))}
          />
        </div>
      ))}
    </>
  );
}

MultiSelectChecklistFilter.propTypes = {
  filterTitle: PropTypes.string,
  filterParam: PropTypes.oneOf(FILTER_PARAMS).isRequired,
  filterOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.oneOfType(PropTypes.number, PropTypes.string)
    })
  ).isRequired,
  filterTooltipText: PropTypes.string
};

MultiSelectChecklistFilter.defaultProps = {
  filterTitle: null,
  filterTooltipText: null
};
